exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".square-image[data-v-49ef3190]{max-height:100%;max-width:100%;object-fit:contain}.placeholder[data-v-49ef3190]{background:#f8f9fa;bottom:0;left:0;position:absolute;right:0;top:0}.lazyloaded+.placeholder[data-v-49ef3190]{display:none}", ""]);

